import ReactDatePicker from 'react-datepicker';
import { SearchInput } from '../../../../components';
import SelectJobDropdown from '../../../../components/global-components/selectJobDropdown';
import SelectUserDropdown from '../../../../components/global-components/selectUserDropdown';
import SelectSubAccountDropdown from '../../../../components/global-components/selectSubAccountDropdown';
import './ShipmentHistoryFilters.scss';

interface Props {
  search: string;
  onChangeSearch: (search: string) => void;
  shipmentStartDate: Date | null;
  shipmentEndDate: Date | null;
  onChangeShipmentDates: (dates: [Date | null, Date | null]) => void;
  onChangeShipmentRawDates: (event: React.FocusEvent<HTMLInputElement>) => void;
  userEmail: string;
  onChangeUser: (email: string) => void;
  subAccountNumber: string;
  onChangeSubAccountNumber: (subAccountNumber: string) => void;
  selectedJob: string;
  onSelectJob: (job: string) => void;
  isAdmin: boolean;
}

export default function ShipmentHistoryFilters({
  search,
  onChangeSearch,
  shipmentStartDate,
  shipmentEndDate,
  onChangeShipmentDates,
  onChangeShipmentRawDates,
  userEmail,
  onChangeUser,
  subAccountNumber,
  onChangeSubAccountNumber,
  selectedJob,
  onSelectJob,
  isAdmin,
}: Props) {
  return (
    <div className='ShipmentHistoryFilters'>
      <div className='SearchInputContainer'>
        <SearchInput
          value={search}
          onChange={onChangeSearch}
        />
      </div>
      <div className='NonSearchFilters'>
        <div className='ShipmentDateContainer DateRangeContainer'>
          <label className='form-label labelText'>
            Shipment Date
          </label>
          <ReactDatePicker
            className='form-control ubbe-input DateRange'
            selected={shipmentStartDate}
            startDate={shipmentStartDate}
            endDate={shipmentEndDate}
            onChange={onChangeShipmentDates}
            onChangeRaw={onChangeShipmentRawDates}
            placeholderText='Select dates'
            dateFormat='yyyy-MM-dd'
            monthsShown={2}
            calendarIconClassname='calendarIcon'
            showIcon
            selectsRange
          />
        </div>
        <div className='UsersContainer'>
          <label className='form-label labelText'>
            Users
          </label>
          <SelectUserDropdown
            selectedUserName={userEmail}
            setSelectedUserName={onChangeUser}
            isAdmin={false}
            setHandleToggleChange={() => {}}
          />
        </div>
        <div className='JobsContainer'>
          <label htmlFor='job' className='form-label labelText'>
            Jobs
          </label>
          <SelectJobDropdown
            selectedJob={selectedJob}
            setSelectedJob={onSelectJob}
            dummyOption={'All Jobs'}
            setHandleToggleChange={() => {}}
          />
        </div>
        {isAdmin && (
        <div className='AccountsContainer'>
          <label className='form-label labelText'>
            Accounts
          </label>
          <SelectSubAccountDropdown
            selectedSubAccount={subAccountNumber}
            setSelectedSubAccount={onChangeSubAccountNumber}
          />
        </div>
        )}
      </div>
    </div>
  );
};
